<style>

    .watchlist-dropdown > .dropdown-menu{
        min-width: 412px;
    }
    .watchlist-activity-container{
        max-height: 600px;
        overflow: auto;
        padding: 4px;
    }
    .watchlist-activity-container::-webkit-scrollbar{
        width: 8px;
    }
    .watchlist-activity-container::-webkit-scrollbar-thumb{
        border: 2px solid transparent;
    }
    .watchlist-counter{
        background: var(--primary);
        font-weight: 600;
        position: absolute;
        top: -8px;
        right: -8px;
        color: white;
        height: 14px;
        width: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        font-size: 10px;
    }
</style>

<script>
    import watchlistProduct from './watchlistProduct';

    export default {
        props: [],
        components: {
            watchlistProduct
        },
        mixins: [],
        data: function () {
            return {
                intialized: false,
                loading: {
                    watchlist: false
                },
                watchlist: null
            }
        },
        computed: {
            sorted_products: function(){
                if(!this.watchlist || !this.watchlist.products){
                    return [];
                }
                var products = this.watchlist.products;
                
                return products;
            }
        },
        created: function () {
            if(typeof auth_user === 'object'){
                this.init();
            }
        },
        mounted: function () {
            var self = this;
            
            document.getElementById('WatchlistDropdown').addEventListener('show.bs.dropdown', function () {
                self.init();
            });
            
//            $(document).on('click', '.watchlist-dropdown .dropdown-menu', function (e) {
//                $(this).find('.dropdown-btn').next().hide(); //hide any currently open nested dropdowns
//                e.stopPropagation();
//            });
//           
//            $(document).on('click', '.dropdown-submenu .dropdown-btn', function(e) {
//                var is_hidden = $(this).next('div').css('display') === 'none';
//                $(this).parents('.dropdown-menu').find('.dropdown-menu').hide(); //hide other nested dropdowns
//                if(is_hidden){
//                    $(this).next('div').show(); //manually toggle the nested dropdown 
//                } else {
//                    $(this).next('div').hide(); //manually toggle the nested dropdown 
//                }
//                e.stopPropagation();
//                e.preventDefault();
//            });
                  
            window.bus.$on('watchlist-edited', function(watchlist){
                self.watchlist = watchlist;
            });
        },
        methods: {
            init: function(){
                if(this.intialized){
                    return;
                }
                this.intialized = true;
                this.getWatchlist();
            },
            getWatchlist: function(){
                var self = this;
                if(self.loading.watchlist) {
                    return;
                }
                self.loading.watchlist = true;
                var url = '/api/v5/shop/watchlist';
                var params = {
                    append: ['products']
                };
                axios.get(url, {params: params}).then(function (response) {
                    var watchlist = response.data.data;
                    self.watchlist = watchlist;
                    window.watchlist = self.watchlist;
                    self.loading.watchlist = false;
                    window.bus.$emit('watchlist-loaded', watchlist);
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.watchlist = false;
                });
            },
            onRemoved: function(product){
                var products = this.watchlist.products || [];
                var index = products.map(function(product){
                    return product.id;
                }).indexOf(product.id);
                if(index > -1){
                    products.splice(index, 1);
                }
            },
        }
    };

</script>

<template>
    <div id="WatchlistDropdown" class="dropdown watchlist-dropdown">
        <div class="pointer position-relative" data-toggle="dropdown" role="button">
            <i class="fas fa-fw fs-20 fa-eye icon-color"></i>
            <span class="watchlist-counter" v-if="watchlist && watchlist.products && watchlist.products.length">{{watchlist.products.length}}</span>
        </div>
        <div class="dropdown-menu dropdown-menu-right p-3">
            <div class="style-section-title mb-2">Watchlist</div>
            <div class="text-subtle mb-2">Stay updated! We'll let you know whenever there are changes in product prices.</div>
            
            
            <ul class="nav nav-tabs nav-style-3 mb-2 justify-content-center" role="tablist" hidden>
                <li class="nav-item" role="presentation">
                    <button class="nav-link active fs-16" id="watchlist-activity-tab" data-toggle="tab" data-target="#watchlist-activity" type="button" role="tab" aria-controls="watchlist-activity" aria-selected="true">Activity</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link fs-16" id="watchlist-alerts-tab" data-toggle="tab" data-target="#watchlist-alerts" type="button" role="tab" aria-controls="watchlist-alerts" aria-selected="false">Alerts</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link fs-16" id="watchlist-archived-tab" data-toggle="tab" data-target="#watchlist-archived" type="button" role="tab" aria-controls="watchlist-archived" aria-selected="false">Archived</button>
                </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
                <div class="tab-pane fade show active" id="watchlist-activity" role="tabpanel" aria-labelledby="watchlist-activity-tab">
                    <div class="watchlist-activity-container">
                        <div v-for="product in sorted_products" :key="product.id">
                            <watchlist-product :product="product" @removed="onRemoved"></watchlist-product>
                        </div>
                    </div>
                    <div v-if="!sorted_products.length">
                        You have not added any products to your watchlist
                    </div>
                </div>
                <div class="tab-pane fade" id="watchlist-alerts" role="tabpanel" aria-labelledby="watchlist-alerts-tab">
                    alerts
                </div>
                <div class="tab-pane fade" id="watchlist-archived" role="tabpanel" aria-labelledby="watchlist-archived-tab">
                    archived
                </div>
            </div>
            
            
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/watchlist/watchlistDropdown.vue